<template>
  <div class="upload-photo-area">
    <draggable
      v-model="draggableList"
      :options="{draggable: isEditing ? '.inputGroupItem' : ''}"
      @end="onEnd"
    >
      <div
        :class="['inputGroupItem',{'draggable': isEditing}]"
        v-for="(item, index) in draggableList"
        :key="item.id"
      >
        <div
          class="delete"
          v-if="isEditing"
          @click="_showDeleteModal(index)"
        ><i class="fa fa-times" /></div>
        <div :class="['input-zone', {'isEditingZone': isEditing}]">
          <div class="div-facility">
            <label :class="{ 'required-flag': isEditing }">{{ $t('handover.facility') }}</label>
            <div class="facility-contant">
              <InputField
                class="facility"
                :readonly="!isEditing"
                :showColon="false"
                :value="item.facility || ''"
                @updateValue="val => updatePhotoInfo('facility', index, val)"
                required
              />
            </div>
          </div>
          <div class="div-description">
            <label>{{ $t('handover.description') }}</label>
            <div :class="[{'isEditing': isEditing}, 'desc-contant']">
              <TextField
                class="description"
                :readonly="!isEditing"
                :showColon="false"
                :value="item.description ? item.description : !isEditing ? 'N/A' : ''"
                @updateValue="val => updatePhotoInfo('description', index, val)"
              />
            </div>
          </div>
        </div>
        <div
          :class="['pic-display', {'isEditing': isEditing}]"
          @click="_selectEditPhotoInfo(item, index)"
        >
          <upload-photo
            v-if="isEditing && allowEdit"
            :ref="`upload-photo-${item.id}`"
            :sourceId="item.id"
            :beforeUpload="_beforeUpload"
            :uploadSuccess="_uploadSuccess"
            :uploadError="_uploadError"
            :targetItem="{item, index}"
            :uploadTimeout="_uploadTimeout"
            :additionalInfo="additionalInfo"
            :action="action"
          />
          <div
            class="photo0 clearfix"
            v-if="(!item.files || item.files.length === 0) && isEditing && allowEdit"
          >
            <div class="border-dashed">
              <div class="center">
                <img
                  class="upload-img"
                  src="/cloud-upload.svg"
                  alt="Upload"
                >
                <div class="upload-text">{{ $t('tender.attachment.uploadClickHint') }}</div>
              </div>
            </div>
          </div>
          <div
            v-else
            :class="item.files.length <= 2 ? 'photo2' : 'photo4'"
          >
            <div
              v-for="photo in item.files"
              :key="photo.id"
              class="photo-contain"
            >
              <img
                class="photo"
                :src="getImageUrl(photo)"
                :id="photo.id"
                @load="showPhoto(photo, item.files.length)"
              >
              <i
                class="fa fa-times delete-photo"
                v-if="isEditing && allowEdit"
                @click.prevent.stop="_deleteOnePhoto(photo, item, index)"
              />
            </div>
          </div>
        </div>
      </div>

      <modal
        modalId="delete-make-sure-modal"
        ref="deleteMakeSureModal"
      >
        <div slot="content">
          <pre class="modal-pure-text">{{ $i18n.t('deleteConfirmMsg') }}</pre>
        </div>
        <div slot="btns">
          <button
            @click="_deleteOnePhotoInfo"
            class="btn btn--orange"
          >{{ $t('action.delete') }}</button>
          <button
            @click="_closeDeleteModal"
            class="btn btn--darkblue"
          >{{ $t('action.cancel') }}</button>
        </div>
      </modal>
    </draggable>
  </div>
</template>

<script>
import UploadPhoto from './UploadPhoto'
import InputField from '@/controls/InputField'
import TextField from '@/controls/TextField'
import notification from '@/utils/notification'
import draggable from 'vuedraggable'
import lodash from 'lodash'
import Modal from '@/controls/Modal'
import { useBaseUrl } from '@/utils/http/hook'

export default {
  name: 'uploadPhotoArea',
  components: {
    InputField,
    TextField,
    UploadPhoto,
    draggable,
    Modal,
  },
  props: {
    photoesInfo: {
      type: Array,
      default: [],
    },
    action: {
      type: String,
      default: '',
    },
    additionalInfo: {
      type: Object,
      default: () => ({}),
    },
    uploadSuccess: {
      type: Function,
      required: true,
    },
    uploadError: {
      type: Function,
      default: () => {},
    },
    uploadTimeout: {
      type: Function,
      default: () => {},
    },
    updatePhotoInfo: {
      type: Function,
      required: true,
    },
    deleteOnePhotoInfo: {
      type: Function,
      required: true,
    },
    selectEditPhotoInfo: {
      type: Function,
      default: () => {},
    },
    isEditing: {
      type: Boolean,
      required: true,
    },
    allowEdit: {
      type: Boolean,
      default: false,
    },
    deleteOnePhoto: {
      type: Function,
      required: true,
    },
    beforeUpload: {
      type: Function,
      default: () => {},
    },
    onDragEnd: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      draggableList: lodash.cloneDeep(this.photoesInfo),
      deleteMakeSureModal: '',
      _selectedPhotoListIndex: '',
      _selectedPhotoListItem: '',
      baseURL: useBaseUrl(),
    }
  },
  watch: {
    photoesInfo (val) {
      this.draggableList = lodash.cloneDeep(this.photoesInfo)
    },
  },
  methods: {
    _beforeUpload (xhr, file) {
      return this.beforeUpload(xhr, file)
    },
    _uploadSuccess (files) {
      this.uploadSuccess(files)
    },
    _uploadError (text) {
      notification.fireNotification(false, text)
    },
    _uploadTimeout (e, file) {
      notification.fireNotification(false, `${file.name} Timeout`)
    },
    _showDeleteModal (index) {
      this._selectedPhotoListIndex = index
      this.deleteMakeSureModal && this.deleteMakeSureModal.open()
    },
    _deleteOnePhoto (photo, item, index) {
      this.deleteOnePhoto(photo, item, index)
    },
    _deleteOnePhotoInfo () {
      this.deleteOnePhotoInfo(this._selectedPhotoListIndex)
      this._closeDeleteModal()
    },
    _closeDeleteModal () {
      this.deleteMakeSureModal && this.deleteMakeSureModal.close()
    },
    _selectEditPhotoInfo (item, index) {
      if (this.isEditing) {
        this._selectedPhotoListIndex = index
        this._selectedPhotoListItem = item
        if (item.files.length < 4) {
          this.$refs[`upload-photo-${item.id}`] && this.$refs[`upload-photo-${item.id}`][0].popupSelectFile()
        } else {
          notification.fireNotification(false, 'Please upload no more than 4 photos.')
        }
        this.selectEditPhotoInfo(item, index)
      }
    },
    async _initDeleteMakeSureModal () {
      this.deleteMakeSureModal = this.$refs.deleteMakeSureModal
    },
    onEnd (val) {
      this.onDragEnd(this.draggableList)
    },
    makePhotoRatote (photoId, orientation, length) {
      const img = $($(`#${photoId}`)[0])
      switch (orientation) {
        case '3':
          img.css('transform', `rotate(180deg)`)
          break
        case '6':
          img.css('transform', `rotate(90deg)`)
          length === 1 ? img.css('max-height', `400px`) : img.css('max-height', `200px`)
          break
        case '8':
          img.css('transform', `rotate(270deg)`)
          length === 1 ? img.css('max-height', `400px`) : img.css('max-height', `200px`)
          break
      }
      img.css('opacity', 1)
    },
    showPhoto (photo, length) {
      // because pdf rotate picture has a problem so annotation below code
      // setTimeout(() => {
      //   this.$nextTick(() => {
      //     this.makePhotoRatote(photo.id, lodash.get(photo, 'metaData.orientation'), length)
      //   })
      // }, 300)
    },
    getImageUrl (photo) {
      const arr = photo.filename.split('.')
      const suffix = arr[arr.length - 1]
      const checksum = photo.checksum || photo.metaData.checksum
      return `${this.baseURL}/static/${checksum}.${suffix}`
    },
  },
  async mounted () {
    await this._initDeleteMakeSureModal()
  },
}
</script>

<style lang="scss">
@import "~styles/popup";
  div.upload-photo-area {
    .draggable {
      cursor: move;
    }
    background: #FAFBFC;
    .inputGroupItem {
      box-shadow: 0 2px 4px 0 rgba(212, 212, 212, 0.5);
      position: relative;
      height: 400px;
      display: flex;
      margin-top: 15px;
      .delete {
        position: absolute;
        right: -20px;
        cursor: pointer;
        font-size: 1.2rem;
        color: #DADADA;
      }
      img.upload-img {
        height: 40px;
        width: 40px;
      }
      img {
        object-fit: contain;
      }
      .pic-display {
        width: 400px;
        height: 400px;
        min-width: 400px;
        background: #F2F6F8;
        position: relative;
        .photo0 {
          display: block;
          text-align: center;
          .upload-text {
            margin-top: 20px;
          }
        }
        .photo-contain {
          height: 100%;
          position: relative;
          text-align: center;
          display: inline-block;
          color: #DADADA;
          i {
            top: 0;
            position: absolute;
            right: 0;
            font-size: 17px;
          }
        }
        img.photo {
          // opacity: 0;
        }
        .photo .delete-photo {
          float: right;
          top: 0;
        }
        .photo2 {
          height: 100%;
          width: 100%;
          display: flex;
          .photo-contain {
            flex: 1;
            line-height: 400px;
            img {
              max-height: 400px;
            }
          }
        }
        .photo4 {
          height: 100%;
          width: 100%;
          font-size: 0;
          .photo-contain {
            width: 200px;
            height: 200px;
            line-height: 200px;
            vertical-align: text-bottom;
            img {
              height: 200px;
            }
          }
        }
        .border-dashed {
          border: 1px dashed #000;
          width: 380px;
          height: 380px;
          margin: 10px 10px 10px 10px;
          .center {
            margin-top: 50%;
            top: -40px;
            position: relative;
          }
        }
      }
      .input-zone.isEditingZone {
        .facility-contant,
        .desc-contant {
          border: 1px solid #B4B4B4;
        }
      }
      .input-zone {
        flex: 1;
        padding: 0 15px;
        height: 400px;
        background-color: white;
        overflow: hidden;
        label {
          margin-top: 0;
          font-weight: bold;
          color: #0C3A58;
          height: 20px;
          margin-bottom: 5px;
        }
        .div-facility {
          margin-top: 10px;
          word-break: break-all;
        }
        .div-description {
          margin-top: 20px;
        }
        .facility-contant {
          height: 40px;
          line-height: 40px;
          .facility span{
            display: inline-block;
            margin-left: 10px;
            width: calc(100% - 15px);
            max-width: calc(100% - 15px);
            overflow: hidden;
            height: 40px;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          input {
            padding-left: 10px;
          }
        }
        .text-input {
          margin: 0;
        }
        .desc-contant {
          min-height: 42px;
          max-height: 275px;
          overflow-y: auto;
          pre {
            padding-left: 10px;
            word-break: break-word;
            p {
              width: 99%;
            }
          }
        }
        .desc-contant.isEditing {
          background: white;
        }
        input {
          border: none;
          width: 100%;
          height: 38px !important;
        }
        textarea {
          margin: 0;
          padding-top: 4px;
          border: none;
          width: 100%;
        }
      }
      .isEditing {
        cursor: pointer;
      }
    }
}
</style>
